<div class="auto-answers" *ngIf="autoAnswers.length > 0">
  <div class="bc-visitor-messages clearfix">
    <div class="chat-message clearfix chat-message-received">
      <div class="chat-message-text" *ngFor="let a of autoAnswers">
        <span *ngIf="a.Text && workItem.ChatName" class="auto-answer-name">{{ workItem.ChatName }}</span>
        <span *ngIf="a.Text && !workItem.ChatName" class="auto-answer-name">{{ "bcChatMessages.defaultVisitorName" | translate }}</span>
        <span *ngIf="a.Text">{{ a.Text }}</span>

        <div class="auto-answer-action" *ngIf="a.autoAnswerFields">
          <span>{{ a.autoAnswerFields.Action | translate }}</span>
          <span>"{{ a.autoAnswerFields.CannedMsgName }}"</span>
          <span>{{ a.autoAnswerFields.Vote | translate }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="bc-timestamp bc-visitor-last-message">
    <span>{{ moment(autoAnswers[autoAnswers.length-1].Created).format('LT') }}</span>
  </div>
</div>
